import { SectionHeader } from "@graphcommerce/next-ui";
import { Box, FormControl, MenuItem, Select, TextField } from "@mui/material";

export default function AddressRow(props) {
  const { country, setCountry, region, setRegion, setZipCode, countries } = props;

  const regions = country?.available_regions;

  return (
    <>
      <SectionHeader
        labelLeft={"Delivering To:"}
      />
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        mb: 5,
        flexWrap: 'wrap'
      }}>
        <Box
          sx={{
            marginRight: 4,
            marginBottom: 2
          }}>
          <FormControl>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              defaultValue={country}
              value={country}
              onChange={(e) => {
                setCountry(e.target.value);
              }}
              MenuProps={{
                style: { maxHeight: 250 }
              }}
              sx={{
                width: 250
              }}
            >
              {countries?.map((item) => (
                <MenuItem
                  value={item}
                >{item?.full_name_locale}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {regions && <Box>
          <FormControl>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              defaultValue={region}
              value={region}
              onChange={(e) => {
                setRegion(e.target.value);
              }}
              MenuProps={{
                style: { maxHeight: 250 }
              }}
              sx={{
                width: 200
              }}
            >
              <MenuItem value={""}>{"None"}</MenuItem>
              {regions?.map((item) => (
                <MenuItem value={item.code}>{item.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>}
      </Box>

      {regions && region !== "" &&

        <>

          <SectionHeader
            labelLeft={"Delivery Zip Code:"}
          />

          <Box>
            <FormControl>
              <TextField
                onChange={(e) => { setZipCode(e.target.value) }}
                sx={{
                  '&:focus': {
                    outline: 'none',
                  }
                }}
              />
            </FormControl>
          </Box>

        </>

      }

    </>
  );
}